module.exports = __webpack_public_path__ + "static/media/mc-confirmation-celular-black.8101f243.svg";